import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import em from 'polished/lib/helpers/em';
import { ACTIVE_YEAR } from '@flow/utils/constants';

const SocialMediaNavigationContainer = styled.div`
  font-size: 2.8em;
  margin-bottom: 1em;
  text-transform: uppercase;
  font-family: Flow-Poster-Bold;
  color: ${props => props.color};
  font-weight: normal;
  line-height: ${em(4.8, 2.8)};
  
  @media (max-width: 900px) {
    font-size: ${28 / (900 * 0.01)}vw;
  }
  
  @media (max-width: 550px) {
    font-size: 2em;
  }
  
  a {
    color: ${props => props.color};
    
    &:after {
      content: ' / ';
      display: inline-block;
      padding: 0 .5em;
    }
    
    &:last-child {
      &:after {
        display: none;
      }
    }
  }
  
  &:last-child {
    margin-bottom: 0;
  }
`;

const SomeTitle = styled.span`
  display: inline-block;
  padding-right: .5em;
  
  &:last-child {
    padding-right: 0;
    //padding-left: .5em;
  }
  a {
    font-family: Flow-Poster-Bold !important;
  }
`;

const SomeLink = styled.span`
  display: inline-block;
  padding-right: .5em;
  font-family: Flow-Poster-Bold;
  font-feature-settings:"liga", "dlig";
  
  svg {
    vertical-align: text-top;
  }
  
  a {
    font-family: Flow-Poster-Bold !important;
  }
`;

interface Props {
  highlightColor?: string;
  color?: string;
  flow_hashtag?: string;
}

const SocialMediaNavigation = ({
  highlightColor,
  color,
  flow_hashtag,
}: Props) => {
  return (
    <SocialMediaNavigationContainer color={color}>
      <SomeTitle><FormattedMessage id={'findUsAt'}/></SomeTitle>
      <SomeLink highlightColor={highlightColor}>
        <a href="https://www.facebook.com/FlowFestival" target="_blank" className='typography-logo'>[FACEBOOK]</a>
      </SomeLink>
      <SomeLink highlightColor={highlightColor}>
        <a href="https://twitter.com/flowfestival" target="_blank" className='typography-logo'>[TWITTER]</a>
      </SomeLink>
      <SomeLink highlightColor={highlightColor}>
        <a href="http://instagram.com/flowfestivalhelsinki" target="_blank" className='typography-logo'>[INSTAGRAM]</a>
      </SomeLink>
      <SomeLink highlightColor={highlightColor}>
        <a href="https://play.spotify.com/user/flowfestival" target="_blank" className='typography-logo'>[SPOTIFY]</a>
      </SomeLink>
      <SomeLink highlightColor={highlightColor}>
        <a href="https://www.youtube.com/user/flowfestival" target="_blank" className='typography-logo'>[YOUTUBE]</a>
      </SomeLink>
      <SomeLink highlightColor={highlightColor}>
        <a href="https://www.flickr.com/photos/flowfestival" target="_blank" className='typography-logo'>[FLICKR]</a>
      </SomeLink>
      {/*<SomeTitle className='typography-logo'> {flow_hashtag ? flow_hashtag : `#FlowFestival${ACTIVE_YEAR}`}</SomeTitle>*/}
      <SomeTitle className='typography-logo'>{`#FlowFestival${ACTIVE_YEAR}`}</SomeTitle>
    </SocialMediaNavigationContainer>
  )
};

export default SocialMediaNavigation;


// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/components/navigation/SocialMediaNavigation.tsx